import './index.scss';

import Logo from '../../assets/images/LG-Cobalt@2x.png';

import iconeinstagram from "../../assets/icons/ico-instagram.svg";
import iconelinkedin from "../../assets/icons/ico-linkedin.svg";
import iconewhatsapp from "../../assets/icons/ico-whatsapp.svg";
import { Link } from 'react-router-dom';

export const Rodape = () => {

    return (

        <div className='container-rodape' id='footer'>
            <div className='subcontainer1-rodape'>
                <div className='logotipo-cobalt'>
                    <img alt={Logo} src={Logo} />
                </div>
                <div className='buttons-header'>
                    <Link to={"/cadastro"} className='button-header primary'> Abra sua conta </Link>
                    <a className="button-header" href="https://www.iamsimple.com.br/cobalt" target="_blank" rel="noopener noreferrer"> Acessar Plataforma  </a>

                </div>
            </div>
            <div className='subcontainer2-rodape' style={{width:"100%"}}>
                <div className='menu contact'>
                    <a href='https://g.co/kgs/gd9FE1h' target="_blank" className='address'>
                        Rua Martiniano de Carvalho, 169,
                        Sala 33 - Bela Vista - São Paulo
                        01321-000
                    </a>
                    <a href="https://wa.me/5511973667387" target="_blank" rel="noopener noreferrer" className='whatsapp' >
                        <img alt='Whatsapp' src={iconewhatsapp} />
                        <p>+55 11 <span>97366-7387</span></p>
                    </a>
                   
                </div>

                    <div className='menu about'>
                        <h1>Sobre a Cobalt</h1>
                        <Link to={"/quem-somos"}>Quem somos</Link>
                        <Link to={"/operacional-passo-a-passo"}>Operacional passo-a-passo</Link>
                    </div>
                    <div className='menu enterprise'>
                        <h1>Para sua empresa</h1>
                        <Link to="/cambio-pronto">Câmbio pronto</Link>
                        <Link to="/produtos-de-credito">Produtos de crédito</Link>
                        <Link to="/produtos-de-protecao">Produtos de proteção</Link>
                        {/* <Link to="/multiplas-cotacoes">Múltiplas cotações</Link>
                        <Link to="/produtos-exclusivos">Produtos exclusivos</Link> */}
                    </div>
                    <div className='menu for-you'>
                        <h1>Para você</h1>
                        <Link to="/produtos-para-voce" state={{tab:2}}>Câmbio para viagens</Link>
                        <Link to="/produtos-para-voce" state={{tab:1}}>Recebimento de salários</Link>
                        <Link to="/produtos-para-voce" state={{tab:3}}>Intercâmbio</Link>
                        <Link to="/produtos-para-voce" state={{tab:3}}>Estude no exterior</Link>
                    </div>
                   
                    <div className='menu social' style={{ padding: '0' }}>
                        <h1>Redes sociais</h1>
                        <div className='icons-social'>
                            <a href="https://www.instagram.com/cobaltsolucoesfinanceiras/" target="_blank" rel="noopener noreferrer"> <img alt='Instagram' src={iconeinstagram} /> </a>
                            <a href="https://www.linkedin.com/company/cobalt-solucoes-financeiras/" target="_blank" rel="noopener noreferrer"> <img alt='Linkedin' src={iconelinkedin} /> </a>

                        </div>
                    </div>
            </div>
            <div className='subcontainer3-rodape'></div>
        </div>

    )

}
